/* Constant feature flag name for enabling the password editor through the roster module. */
export const ROSTER_ENABLE_NON_ADMIN_PASSWORD = "roster.enableNonAdminPassword";
/** Constant flag name for enabling the V2 roles editor. If disabled, fall back to a legacy checkbox-based approach. */
export const ROSTER_ROLES_EDITOR_V2 = "roster.rolesEditorV2";
/** Constant flag name for using separate edit pages for editing an employee on the roster */
export const ROSTER_SEPARATE_EDIT_PAGES = "roster.separateEditPages";
/** Constant flag name for enabling the link to the direct deposit page. */
export const ROSTER_DIRECT_DEPOSIT = "roster.directDeposit";
